import { Space } from 'antd';
import { useLanguage } from '../../utils/LanguageContext';
import accountTranslations from '../AccountSettings/AccountSettings.lang.json';
import translations from '../ComponentsTranslations.lang.json';
import { EditableValues } from '../common/CommonComponents.js';
import EmailView from '../EmailView';
import EmailForm from '../EmailForm';
import AddressView from '../AddressView';
import AddressForm from '../AddressForm';
import PhoneNumberView from '../PhoneNumberView';
import PhoneNumberForm from '../PhoneNumberForm';
import LanguagePreferenceView from '../LanguagePreferenceView.js';
import LanguagePreferenceForm from '../LanguagePreferenceForm.js';
import PasswordView from '../PasswordView.js';
import PasswordForm from '../PasswordForm.js';
import { useAuth } from '../../utils/AuthContext.js';
import AdminEmployerView from '../AdminEmployerView.js';
import AdminEmployerForm from '../AdminEmployerForm.js';

const ChangePersonalInfo = () => {
  const { lang } = useLanguage(accountTranslations, translations);
  const { user, userAuthenticatedUsingPassword } = useAuth();

  return (
    <Space direction="vertical">
      <EditableValues
        editButtonLabel={lang('editLanguagePreference')}
        viewComponent={LanguagePreferenceView}
        editComponent={LanguagePreferenceForm}
      />

      {userAuthenticatedUsingPassword() && (
        <>
          <EditableValues editButtonLabel={lang('editEmail')} viewComponent={EmailView} editComponent={EmailForm} />

          <EditableValues
            editButtonLabel={lang('changePassword')}
            viewComponent={PasswordView}
            editComponent={PasswordForm}
          />
        </>
      )}

      {!user.isPayrollAdmin && (
        <EditableValues editButtonLabel={lang('editAddress')} viewComponent={AddressView} editComponent={AddressForm} />
      )}

      <EditableValues
        editButtonLabel={lang('editPhoneNumber')}
        viewComponent={PhoneNumberView}
        editComponent={PhoneNumberForm}
      />

      {user.isThirdPartyPayrollAdmin && (
        <EditableValues
          editButtonLabel={lang('editEmployer')}
          viewComponent={AdminEmployerView}
          editComponent={AdminEmployerForm}
        />
      )}
    </Space>
  );
};

export default ChangePersonalInfo;
